import { PAGE_LEVEL } from '@/constants';

/**
 * 资讯模块
 */
export default {
  meta: { localeModules: ['consult'] },
  path: '/consult',
  redirect: '/consult/list',
  children: [
    {
      path: 'list',
      name: 'consult',
      component: () => import('@/pages/consult/index.vue'),
      meta: {
        name: 'routers.consult_information',
        componentName: 'ConsultPage',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    },
    {
      // 资讯详情
      path: 'detail',
      name: 'consultDetail',
      component: () => import('@/pages/consult/detail'),
      meta: {
        name: 'routers.consult_information_detail',
        componentName: 'InformationDetailIndex',
        parent: '/consult/list',
        electronSingle: true
      }
    }
  ]
};
